module.exports = __webpack_public_path__ + "media/images/home/ad_web_banner_square_accon-d9913bba4be6d4aaabb577f16d0176a2.jpg";